import { Team } from './team';

export const TEAMS: Team[] = [
  {
    name: '',
    category: 'incremental',
    description: '',
    member: ['']
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/strategy-overview/teams/teams.ts